import { Link } from 'react-router-dom';
import ThemeToggle from '../ThemeToggle/ThemeToggle';
import './Navbar.css';

export default function Navbar({ onMenuClick }) {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <button 
          className="hamburger-menu"
          onClick={onMenuClick}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <Link to="/" className="navbar-title">
          <h1>MEME之家</h1>
        </Link>
        <ThemeToggle />
      </div>
    </nav>
  );
}
